import React from 'react';
import './EventSingle.css';

import { Lightbox, PageSidebar, PageTitle, TeamItem } from '../../../components';
import { guests } from '../../../constants';
import { getGuestsByIds } from '../../../utils';

import { FaArrowRight, FaCheckSquare } from 'react-icons/fa';

import { useLocation } from 'react-router-dom';



const EventSingle = () => { 

  // Get the event data from the router state
  const location = useLocation();  
  const event = location.state; 

  // Get the guests for this event
  const eventGuests = getGuestsByIds(event.guestIds, guests);

  return (
    <>
      {/* Page Title */}
      <PageTitle title={event.title} page={"Event Single"} />

      <section className='event-single page-single'>

        <div className='event-info page-info'>

          {/* Event Image */}
          <div className='image'>
            <img src={event.image} alt={event.title} />
          </div>

          <div className='content'>

            {/* Event Heading */}
            <h3 className='main-heading'>{event.title}</h3>

            {/* Event Description */}
            {event.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Event Image gallery */}
            <Lightbox images={event.gallery} />

            {/* Event Highlights Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Event Highlights:</h3>
              <p>Here’s what you can expect during the summit:</p>

              {/* List of Highlight Points */}
              <ul>
                {event.highlights.map((highlight, index) => (
                  <li key={index}>
                    <FaArrowRight className='icon' />
                    {highlight}
                  </li>
                ))}
              </ul>
            </div>

            {/* Event Essentials Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>What to Bring:</h3>
              <p>Ensure you're fully prepared for the summit:</p>

              {/* List of Event Essentials */}
              <ul>
                {event.essentials.map((session, index) => (
                  <li key={index}>
                    <FaCheckSquare className='icon' />
                    {session}
                  </li>
                ))}
              </ul>
            </div>

            {/* Event Speakers Section */}
            <div className='team sub-section'>
              <h3 className='sub-heading'>Event Speakers:</h3>
              <div className='box-container'>
                {eventGuests.map((guest) => (
                  <TeamItem
                    key={guest.id}
                    team={guest}
                    type='speaker'
                  />
                ))}
              </div>
            </div> 

            {/* Event Venue Map */}
            <div className="event-map sub-section">
              <h3 className="sub-heading">Event Venue:</h3>
              <iframe
                src={event.venueMap}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Event Venue Map"
              ></iframe> 
            </div>

          </div> 
        
        </div> 

        {/* Sidebar with Event Details */}
        <PageSidebar
          heading={'Event'}
          details={event.details}
          button={{ link: 'Contact-us', title: 'Register Now' }}
        />

      </section>

    </> 
  );
}

export default EventSingle;